var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.4,
    stroke: "#D04C8D",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.938 8.939C9.989 7.885 10.771 7.154 11.927 7.154C13.151 7.154 13.899 7.885 13.899 8.854C13.899 9.568 13.525 9.993 12.879 10.571L11.859 11.472C10.873 12.339 10.856 13.104 11.23 14.651H12.386C12.25 13.308 12.437 12.849 13.27 12.135L14.273 11.319C15.208 10.52 15.786 9.738 15.786 8.701C15.786 6.933 14.307 5.624 12.097 5.624C9.955 5.624 8.374 6.984 8.306 8.939H9.938ZM13.134 16.81C13.134 16.045 12.556 15.501 11.774 15.501C10.992 15.501 10.414 16.045 10.414 16.81C10.414 17.541 11.009 18.085 11.774 18.085C12.539 18.085 13.134 17.541 13.134 16.81Z",
    fill: "#D04C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.4609b14b.svg";
export { ForwardRef as ReactComponent };